import { TextField } from "@mui/material";

const Input = (props: any) => (
    <TextField
      fullWidth
      id={`outlined-${props?.name || props?.elementName}`}
      label={props?.name || props?.elementName}
      onChange={props?.onChange}
    />
  );

export default Input;
